import { SyncRoute } from '@/system-modules/sync/v1/api/SyncRoute'
import { EnumRouteType } from '@/contracts/core/api/enum/EnumRouteType'
import { ApiResponse } from '@/contracts/core/api/entity/ApiResponse'
import { OperationPage } from '@/contracts/system-modules/sync/dto/OperationPage'
import { GetOperationsParams } from '@/system-modules/sync/v1/api/v1/sync/GetOperations/Dto/GetOperationsParams'

export class GetOperationsRoute extends SyncRoute<GetOperationsParams, OperationPage> {
  type(): EnumRouteType {
    return EnumRouteType.GET
  }

  url(): string {
    return '/api/system/v1/sync/operations'
  }

  /** Без сервера новых операций нет */
  offline(params: GetOperationsParams): Promise<ApiResponse<OperationPage>> {
    return Promise.resolve(new ApiResponse({
      success: true,
      data: new OperationPage({ operations: [], next: params.after, hasMore: false }),
    }))
  }
}
